import { isAnyArray } from 'is-any-array';
export function checkMatrix(data) {
    if (!isAnyArray(data) || !isAnyArray(data[0])) {
        throw new Error(`2D data should be a matrix`);
    }
}
//# sourceMappingURL=checkMatrix.js.map